module.exports = __webpack_public_path__ + "images/123_2048.jpg";